module.exports = __webpack_public_path__ + "static/media/scanner_icon.cdb22151.png";